import React, { useState, useEffect } from "react";
import ReactEcharts from "echarts-for-react";
import { useAuth } from "../../context/auth";
import { Redirect } from "react-router-dom";
import { groupBy, useInterval } from "../../Utils";
import cloneDeep from "lodash.clonedeep";
import { vavAhuGetVavAhuData } from "../../api/vav";

function Vav(props) {
    const vavImage =
        "image://data:image/png;base64,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";

    const ahuImage =
        "image://data:image/png;base64,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";

    const refreshInterval = 60000;
    const { getAuthTokens } = useAuth();
    const [currentCounter, setCurrentCounter] = useState(0);
    const [currentTowerIndex, setCurrentTowerIndex] = useState(0);

    function getFloor(index) {
        var floors = [];
        if (index === "orq_nt") {
            for (var i = 0; i < 51; i++) {
                floors.push(i.toString());
            }
            floors[0] = "GF";
        }
        else if (index === "orq_st") {
            for (var i = 8; i < 34; i++) {
                floors.push(i.toString());
            }
        } else if (index === "bfc_1") {
            for (var i = 0; i < 34; i++) {
                floors.push(i.toString());
            }
            floors[0] = "GF";
        } else if (index === "bfc_2") {
            for (var i = 1; i < 51; i++) {
                floors.push(i.toString());
            }
        } else if (index === "cbd_3") {
            for (var i = 0; i < 47; i++) {
                floors.push(i.toString());
            }
        }

        return floors;
    }

    const [option, setOption] = useState({
        grid: {
            bottom: 150
        },
        xAxis: {
            type: "category",
            scale: true,
            axisLine: { show: true, lineStyle: { color: "#333" } },
            splitLine: {
                show: true,
                lineStyle: { color: "#333", type: "dotted" }
            },
            name: "TEMPERATURE (°C)",
            nameLocation: "center",
            nameGap: 40,
            nameTextStyle: {
                color: "#999999",
                fontSize: 20
            },
            axisLabel: { color: "#888", fontSize: 16 },
            data: [22, 22.5, 23, 23.5, 24, 24.5, 25, 25.5, 26, 26.5, 27]
        },
        yAxis: {
            type: "category",
            scale: true,
            axisLine: { show: true, lineStyle: { color: "#333" } },
            splitLine: {
                show: true,
                lineStyle: { color: "#111", type: "solid" }
            },
            name: "FLOOR",
            nameLocation: "end",
            nameGap: 13,
            nameTextStyle: {
                color: "#999999",
                fontSize: 20
            },
            axisLabel: { color: "#888", fontSize: 16 },
            data: []
        },
        legend: {
            bottom: 0,
            orient: "horizontal",
            itemWidth: 80,
            itemHeight: 80,
            itemGap: 90,
            data: [
                { name: "VAV TEMP", icon: vavImage },
                { name: "AHU TEMP", icon: ahuImage }
            ],
            textStyle: { color: "#999999", fontSize: 15 }
        },
        series: [
            {
                name: "VAV TEMP",
                type: "scatter",
                data: []
            },
            {
                name: "AHU TEMP",
                type: "scatter",
                data: []
            }
        ]
    });

    const mainDiv = (
        <div className="heat has-subtitle">
            <div className="main-container">
                <div className="subtitle-gp">
                    <span className="line" />
                    <span>
                        <div>
                            <img src="/images/subtitle-heat-icon.png" />
                        </div>
                        <div style={{ position: "relative" }}>
                            <div className="subtitle">VAV/AHU Temperature</div>
                        </div>
                    </span>
                    <span className="line" />
                </div>
                <div className="pane1">
                    <div className="pane-holder widget-tran">
                        <div className="widget-header row no-gutters">
                            <div
                                className={
                                    "widget-title col-12 building-" +
                                    props.towers[currentTowerIndex]
                                        .buildingIndex
                                }
                            >
                                {props.towers[currentTowerIndex].buildingName}
                                <span className="title-m">
                                    {" " +
                                        props.towers[currentTowerIndex]
                                            .towerName}
                                </span>
                            </div>
                        </div>
                        <div className="row no-gutters">
                            <ReactEcharts
                                option={option}
                                style={{ height: "2040px", width: "100%" }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    function onVavAhuGetVavAhuData(ret, index) {
        var vavData = [];
        var ahuData = [];
        console.log(ret)
        if ("vav" in ret.info) {
            if ("data" in ret.info.vav) {
                var temperatureGroup = 0;
                var group = [];
                var symbolSize = 20;

                for (var i = 0; i < 11; i++) {
                    group.push({ counter: 0 });
                }

                var start = 0;
                var end = ret.info.vav.data.length;

                if(ret.info.vav.buildingName==="orq_st"){
                    end = 34;
                    start = 8;
                }

                for (var i = start; i < end; i++) {
                    if (ret.info.vav.data[i].data.length) {
                        for (var k = 0; k < 11; k++) {
                            group[k].counter = 0;
                        }
                        for (
                            var j = 0;
                            j < ret.info.vav.data[i].data.length;
                            j++
                        ) {
                            if (ret.info.vav.data[i].data[j].value != 0) {
                                if (ret.info.vav.data[i].data[j].value < 22.5) {
                                    temperatureGroup = 0;
                                } else if (
                                    ret.info.vav.data[i].data[j].value < 23
                                )
                                    temperatureGroup = 1;
                                else if (
                                    ret.info.vav.data[i].data[j].value < 23.5
                                )
                                    temperatureGroup = 2;
                                else if (
                                    ret.info.vav.data[i].data[j].value < 24
                                )
                                    temperatureGroup = 3;
                                else if (
                                    ret.info.vav.data[i].data[j].value < 24.5
                                )
                                    temperatureGroup = 4;
                                else if (
                                    ret.info.vav.data[i].data[j].value < 25
                                )
                                    temperatureGroup = 5;
                                else if (
                                    ret.info.vav.data[i].data[j].value < 25.5
                                )
                                    temperatureGroup = 6;
                                else if (
                                    ret.info.vav.data[i].data[j].value < 26
                                )
                                    temperatureGroup = 7;
                                else if (
                                    ret.info.vav.data[i].data[j].value < 26.5
                                )
                                    temperatureGroup = 8;
                                else if (
                                    ret.info.vav.data[i].data[j].value < 27
                                )
                                    temperatureGroup = 9;
                                else temperatureGroup = 10;

                                group[temperatureGroup].counter++;
                            }
                        }

                        for (var j = 0; j < 11; j++) {
                            if (group[j].counter > 0) {
                                var symbolSize_ = 15 * group[j].counter;
                                if (symbolSize_ > 60) symbolSize_ = 60;
                                vavData.push({
                                    symbol: vavImage,
                                    symbolSize: symbolSize_,
                                    value: [j, ret.info.vav.data[i].index-start]
                                });
                            }
                        }
                    }
                }
            }
        }

        if ("ahu" in ret.info) {
            if ("data" in ret.info.ahu) {
                var temperatureGroup = 0;
                var group = [];

                for (var i = 0; i < 11; i++) {
                    group.push({ counter: 0 });
                }

                var start = 0;
                var end = ret.info.ahu.data.length;

                if(ret.info.vav.buildingName==="orq_st"){
                    end = 34;
                    start = 8;
                }

                for (var i = start; i < end; i++) {
                    for (var k = 0; k < 11; k++) {
                        group[k].counter = 0;
                    }
                    if (ret.info.ahu.data[i].data.length) {
                        for (
                            var j = 0;
                            j < ret.info.ahu.data[i].data.length;
                            j++
                        ) {
                            if (ret.info.ahu.data[i].data[j].value != 0) {
                                if (ret.info.ahu.data[i].data[j].value < 22.5) {
                                    temperatureGroup = 0;
                                } else if (
                                    ret.info.ahu.data[i].data[j].value < 23
                                )
                                    temperatureGroup = 1;
                                else if (
                                    ret.info.ahu.data[i].data[j].value < 23.5
                                )
                                    temperatureGroup = 2;
                                else if (
                                    ret.info.ahu.data[i].data[j].value < 24
                                )
                                    temperatureGroup = 3;
                                else if (
                                    ret.info.ahu.data[i].data[j].value < 24.5
                                )
                                    temperatureGroup = 4;
                                else if (
                                    ret.info.ahu.data[i].data[j].value < 25
                                )
                                    temperatureGroup = 5;
                                else if (
                                    ret.info.ahu.data[i].data[j].value < 25.5
                                )
                                    temperatureGroup = 6;
                                else if (
                                    ret.info.ahu.data[i].data[j].value < 26
                                )
                                    temperatureGroup = 7;
                                else if (
                                    ret.info.ahu.data[i].data[j].value < 26.5
                                )
                                    temperatureGroup = 8;
                                else if (
                                    ret.info.ahu.data[i].data[j].value < 27
                                )
                                    temperatureGroup = 9;
                                else temperatureGroup = 10;

                                group[temperatureGroup].counter++;
                            }
                        }

                        for (var j = 0; j < 11; j++) {
                            if (group[j].counter > 0) {
                                ahuData.push({
                                    symbol: ahuImage,
                                    symbolSize: 60,
                                    value: [j, ret.info.ahu.data[i].index-start]
                                });
                            }
                        }
                    }
                }
            }
        }
        console.log(vavData)
        const option_ = cloneDeep(option); // immutable
        //console.log(props.towers[index].towerIndex);
        option_.yAxis.data = getFloor(props.towers[index].towerIndex);
        option_.series[0].data = vavData;
        option_.series[1].data = ahuData;
        setOption(option_);
    }

    function callVavAhuData(index) {
        setCurrentTowerIndex(index);
        vavAhuGetVavAhuData(
            onVavAhuGetVavAhuData,
            {
                buildingName: props.towers[index].towerIndex
            },
            index
        );
    }

    useEffect(() => {
        callVavAhuData(0);
    }, []);

    useInterval(() => {
        let counter_ = currentCounter;

        counter_++;
        if (counter_ === 6) {
            counter_ = 0;
        }

        let towerCounter_ = counter_;
        if (towerCounter_ === 4 || towerCounter_ === 5) {
            towerCounter_ = 4;
        }

        callVavAhuData(towerCounter_);
        setCurrentCounter(counter_);
    }, refreshInterval);

    if (getAuthTokens() == null) {
        const referer = "/404";
        return <Redirect to={referer} />;
    } else return <div> {mainDiv} </div>;
}

export default Vav;
